export namespace Dnd {
  export const ItemTypes = {
    QUICKLINK: 'widget.quicklink',
    COLUMN_DRAG: 'table.column'
  };
}
